export { default as ProdigyHeader } from './ProdigyHeader';
export { default as HowToCrack } from './HowToCrack';
export { default as GoalWiseTestSeries } from './GoalWiseTestSeries';
export { default as StarPoints } from './StarPoints';
export { default as EducatorsList } from './EducatorsList';
export { default as ShareBlock } from './ShareBlock';
export { default as AboutProdigy } from './AboutProdigy';
export { default as ProdigyFAQs } from './ProdigyFAQs';
export { default as AppInstall } from './AppInstall';
